module.exports = function() {
  return new Worker("/" + "3rdparty/Decoder.worker.e28c1fd5e22c8d127eed.js");
};